import React from 'react';
import Seo from "./Seo"

class ExploreMap extends React.Component {
	render() {
		return (
			<div>
				<Seo title="Explore Map" />
			</div>
		)
	}
}

export default ExploreMap;



// WEBPACK FOOTER //
// ./src/components/ExploreMap.js